import { useState } from 'react';
import { Button } from './ui/button';
import RaceModal, { RaceData } from './Modals/RaceModal';
import { cn } from '../lib/utils';

interface RaceSelectionProps {
  races: RaceData[];
  selectedRace?: RaceData | null;
  onRaceSelect: (race: RaceData) => void;
  onRaceAdd: (race: RaceData) => Promise<void>;
  className?: string;
}

export default function RaceSelection({
  races,
  selectedRace,
  onRaceSelect,
  onRaceAdd,
  className,
}: RaceSelectionProps) {
  const [showRaceModal, setShowRaceModal] = useState(false);

  const handleAddRace = async (raceData: RaceData) => {
    await onRaceAdd(raceData);
    setShowRaceModal(false);
    // Auto-select the newly added race
    onRaceSelect(raceData);
  };

  return (
    <div className={cn('space-y-4', className)}>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Select Race
        </label>
        <div className="flex gap-2">
          <select
            className="flex-1 block w-full rounded-md border border-gray-300 px-3 py-2"
            value={selectedRace?.id || ''}
            onChange={(e) => {
              const raceId = parseInt(e.target.value);
              const race = (races || []).find((r) => r.id === raceId);
              if (race) {
                onRaceSelect(race);
              }
            }}
          >
            <option value="">Select a race...</option>
            {(races || []).map((race) => (
              <option key={race.id} value={race.id}>
                {race.name} - {race.date} - {race.distance}
              </option>
            ))}
          </select>
          <Button
            type="button"
            onClick={() => setShowRaceModal(true)}
            variant="outline"
            className="whitespace-nowrap"
          >
            Add Race
          </Button>
        </div>
      </div>

      {selectedRace ? (
        <div className="p-4 bg-gray-50 rounded-md">
          <h4 className="font-medium text-gray-900">Selected Race:</h4>
          <p className="text-sm text-gray-600">
            <strong>{selectedRace.name}</strong> - {selectedRace.date} -{' '}
            {selectedRace.distance}
          </p>
          {selectedRace.description ? (
            <p className="text-sm text-gray-500 mt-1">
              {selectedRace.description}
            </p>
          ) : null}
        </div>
      ) : null}

      {showRaceModal ? (
        <RaceModal
          show={showRaceModal}
          onClose={() => setShowRaceModal(false)}
          onSubmit={handleAddRace}
          disabled={false}
        />
      ) : null}
    </div>
  );
}
